'use client';

import Container from '@mui/material/Container';
import { Stack } from '@mui/system';
import React from 'react';
import { IEvent } from 'src/types';

import EventDetailsContent from '../event-details-content';
import EventDetailsDesktopHeader from '../event-details-header-desktop';

type Props = {
  event: IEvent;
};

export default function EventDetailsDesktopView({ event }: Props) {
  return (
    <Container sx={{ px: { md: 7, lg: 20, xl: 23 } }} maxWidth="xl">
      <Stack direction="row" justifyContent="space-between" gap={2}>
        {event && <EventDetailsContent event={event} />}
        {event && <EventDetailsDesktopHeader event={event} />}
      </Stack>
    </Container>
  );
}
